(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Footer: turns menu blocks into smooth, accessible accordions below 750px.
     Above 750px every accordion class / attribute is removed, so the
     tablet and desktop layouts are exactly as designed. */
  (function () {
    var MOBILE = '(max-width: 749.98px)';
    var REDUCED = '(prefers-reduced-motion: reduce)';
    var counter = 0;

    // Find the heading + collapsible panel inside a footer block (or null if not a menu-like block)
    function getParts(item) {
      if (item.querySelector('details')) return null; // block already has its own accordion
      if (!(item.matches('[class*="menu"]') || item.querySelector('[class*="menu"]'))) return null;

      var heading = item.querySelector('.menu__heading, [class*="menu__heading"], h2, h3, h4, h5, h6');
      var list = item.querySelector('ul');
      if (!heading || !list) return null;
      if (list.closest('[class*="social"], [class*="payment"]')) return null;
      if (heading.contains(list) || list.contains(heading)) return null;
      if (!(heading.compareDocumentPosition(list) & Node.DOCUMENT_POSITION_FOLLOWING)) return null;

      // Panel = highest ancestor of the list (inside the block) that does not contain the heading
      var panel = list;
      while (panel.parentElement && panel.parentElement !== item && !panel.parentElement.contains(heading)) {
        panel = panel.parentElement;
      }
      return { item: item, heading: heading, panel: panel, enabled: false };
    }

    // Open or close one accordion. `animate` = false applies the state instantly.
    function setOpen(entry, open, animate) {
      var panel = entry.panel;
      var instant = !animate || window.matchMedia(REDUCED).matches;

      entry.item.classList.toggle('is-open', open);
      entry.heading.setAttribute('aria-expanded', String(open));

      // Drop any unfinished animation listener
      if (entry.onEnd) {
        panel.removeEventListener('transitionend', entry.onEnd);
        entry.onEnd = null;
      }

      if (instant) {
        panel.style.height = open ? 'auto' : '0px';
        return;
      }

      if (open) {
        // 0 -> measured height, then release to "auto" so content can reflow
        panel.style.height = panel.scrollHeight + 'px';
        entry.onEnd = function (event) {
          if (event.target !== panel || event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', entry.onEnd);
          entry.onEnd = null;
          if (entry.item.classList.contains('is-open')) panel.style.height = 'auto';
        };
        panel.addEventListener('transitionend', entry.onEnd);
      } else {
        // auto -> fixed px (needs a reflow to register) -> 0
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.height = '0px';
      }
    }

    function toggle(entry) {
      setOpen(entry, !entry.item.classList.contains('is-open'), true);
    }

    function enable(entry) {
      if (entry.enabled) return;
      var h = entry.heading;
      var p = entry.panel;
      entry.item.classList.add('footer-accordion');
      h.classList.add('footer-accordion__heading');
      p.classList.add('footer-accordion__panel');
      if (!p.id) p.id = 'footer-panel-' + ++counter;
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-controls', p.id);
      p.style.height = '0px';
      entry.item.classList.remove('is-open');
      h.setAttribute('aria-expanded', 'false');

      entry.onClick = function () { toggle(entry); };
      entry.onKey = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle(entry);
        }
      };
      h.addEventListener('click', entry.onClick);
      h.addEventListener('keydown', entry.onKey);
      entry.enabled = true;
    }

    function disable(entry) {
      if (!entry.enabled) return;
      var h = entry.heading;
      var p = entry.panel;
      h.removeEventListener('click', entry.onClick);
      h.removeEventListener('keydown', entry.onKey);
      if (entry.onEnd) {
        p.removeEventListener('transitionend', entry.onEnd);
        entry.onEnd = null;
      }
      ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (a) { h.removeAttribute(a); });
      p.style.height = '';
      if (!p.getAttribute('style')) p.removeAttribute('style');
      h.classList.remove('footer-accordion__heading');
      p.classList.remove('footer-accordion__panel');
      entry.item.classList.remove('footer-accordion', 'is-open');
      entry.enabled = false;
    }

    function setup(footer) {
      if (footer.dataset.accordionReady) return;
      footer.dataset.accordionReady = 'true';

      var bottom = parseInt(footer.dataset.bottomCount, 10) || 0;
      var children = Array.prototype.slice.call(footer.children);
      var entries = [];
      children.slice(0, children.length - bottom).forEach(function (item) {
        var parts = getParts(item);
        if (parts) entries.push(parts);
      });
      if (!entries.length) return;

      footer._footerAccordions = entries;

      var mql = window.matchMedia(MOBILE);
      function sync() {
        entries.forEach(function (entry) { mql.matches ? enable(entry) : disable(entry); });
      }
      sync();
      if (mql.addEventListener) mql.addEventListener('change', sync);
      else mql.addListener(sync);
    }

    function init() {
      document.querySelectorAll('.footer-content[data-mobile-menu="accordion"]').forEach(setup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    // Theme editor support: re-init on section reload, open a block when it is selected
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target && event.target.closest ? event.target.closest('.footer-accordion') : null;
      if (!item) return;
      var footer = item.closest('.footer-content');
      var entries = (footer && footer._footerAccordions) || [];
      entries.forEach(function (entry) {
        if (entry.item === item) setOpen(entry, true, false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      var track = root.querySelector('.cs5__track');
      var slides = root.querySelectorAll('.cs5__slide');
      var dots = root.querySelectorAll('.cs5__dot');
      var prevBtn = root.querySelector('.cs5__arrow--prev');
      var nextBtn = root.querySelector('.cs5__arrow--next');
      var total = slides.length;
      var index = 0;
      var timer = null;
      var seconds = parseFloat(root.dataset.autoplay) || 0;
      var inEditor = window.Shopify && window.Shopify.designMode;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goTo(n) {
        index = (n + total) % total;
        track.style.transform = 'translateX(' + -100 * index + '%)';

        slides.forEach(function (slide, i) {
          if (i === index) {
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('inert', '');
          }
        });

        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function start() {
        if (total > 1 && seconds > 0 && !reduceMotion && !inEditor && !timer) {
          timer = setInterval(function () {
            goTo(index + 1);
          }, seconds * 1000);
        }
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        start();
      }

      root.csGoTo = goTo;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(index - 1);
          restart();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(index + 1);
          restart();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          restart();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          goTo(index - 1);
          restart();
        } else if (e.key === 'ArrowRight') {
          goTo(index + 1);
          restart();
        }
      });

      // Swipe on touch screens
      var startX = 0;
      var deltaX = 0;
      var justSwiped = false;

      root.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          deltaX = 0;
          stop();
        },
        { passive: true }
      );

      root.addEventListener(
        'touchmove',
        function (e) {
          deltaX = e.touches[0].clientX - startX;
        },
        { passive: true }
      );

      root.addEventListener('touchend', function () {
        if (Math.abs(deltaX) > 50 && total > 1) {
          justSwiped = true;
          goTo(deltaX < 0 ? index + 1 : index - 1);
          setTimeout(function () {
            justSwiped = false;
          }, 350);
        }
        start();
      });

      // A swipe should not count as a tap on the slide link
      root.addEventListener(
        'click',
        function (e) {
          if (justSwiped) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      goTo(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('.cs5:not([data-ready])').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.cs5__slide');
      var root = e.target.closest('.cs5');
      if (!slide || !root || !root.csGoTo) return;
      var slidesList = Array.prototype.slice.call(root.querySelectorAll('.cs5__slide'));
      root.csGoTo(slidesList.indexOf(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wires the header arrows to the theme's own carousel arrows (does not create a second carousel).
    function isCardArrow(el) {
      return !!el.closest('card-gallery, .card-gallery, product-card, .product-card, product-card-gallery');
    }

    function initSection(section) {
      var nav = section.querySelector('[data-pl-nav]');
      if (!nav || nav.dataset.plReady) return;

      var themeArrows = Array.prototype.filter.call(
        section.querySelectorAll('slideshow-arrows'),
        function (el) { return !isCardArrow(el); }
      )[0];
      if (!themeArrows) return;

      var buttons = themeArrows.querySelectorAll('button');
      if (buttons.length < 2) return;

      var prev = buttons[0];
      var next = buttons[buttons.length - 1];
      var myPrev = nav.querySelector('[data-pl-dir="prev"]');
      var myNext = nav.querySelector('[data-pl-dir="next"]');

      themeArrows.setAttribute('data-pl-theme-nav', '');
      nav.dataset.plReady = 'true';
      nav.hidden = false;

      myPrev.addEventListener('click', function () { prev.click(); });
      myNext.addEventListener('click', function () { next.click(); });

      function sync() {
        myPrev.disabled = prev.disabled || prev.getAttribute('aria-disabled') === 'true';
        myNext.disabled = next.disabled || next.getAttribute('aria-disabled') === 'true';
      }
      sync();

      var observer = new MutationObserver(sync);
      [prev, next].forEach(function (btn) {
        observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-pl-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    window.addEventListener('load', initAll);
    setTimeout(initAll, 500);
    setTimeout(initAll, 1500);
    document.addEventListener('shopify:section:load', function () {
      setTimeout(initAll, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
